import React from "react";
import { BrowserView, MobileView } from "react-device-detect";
import { DisplayMobile } from './DisplayMobile';
import { DisplayBrowser } from './DisplayBrowser';

export function CompletedList({ items, toggleCompleteIngredient }) {
  return (
    <>
      <BrowserView>
        <DisplayBrowser
          toggleCompleteIngredient={toggleCompleteIngredient}
          items={items} />
      </BrowserView>
      <MobileView>
        <DisplayMobile
          toggleCompleteIngredient={toggleCompleteIngredient}
          items={items} />
      </MobileView>
    </>
  );
};